import { Table, TableBody, TableRow } from "@mui/material";
import {
  StyledTableCell,
  StyledTableHeadingCell,
} from "../../../../../../common/components/functional/simpleTable/styled";
import { useTranslation } from "react-i18next";
import React from "react";
import {
  DateRange,
  GarnishmentRestriction,
  TalentPaymentProhibition,
} from "../../paymentProhibitionAPI";
import GarnishmentRestrictionItem from "./GarnishmentRestrictionItem";
import FreeMonthItem from "./FreeMonthItem";

interface Props {
  rowItem: TalentPaymentProhibition;
  deleteException: (exceptionId: string, type: string) => void;
  handleExceptionChange: (
    value: string | null,
    exceptionId: string,
    type: string,
    field: string,
  ) => void;
  editing: boolean;
}

const Exceptions = ({
  rowItem,
  deleteException,
  handleExceptionChange,
  editing,
}: Props) => {
  const { t } = useTranslation();

  // Disable exceptions if editing is false or if the rowItem type is SYSTEM
  const disableExceptions = !editing || rowItem.type === "SYSTEM";

  return (
    <React.Fragment>
      {rowItem?.garnishmentRestrictions &&
        rowItem?.garnishmentRestrictions?.length > 0 && (
          <Table
            sx={{
              backgroundColor: "#F3F3F7",
              borderRadius: "4px",
            }}
          >
            <TableBody>
              <TableRow>
                <StyledTableCell
                  colSpan={3}
                  sx={{ padding: "10px 0px 0px 20px" }}
                >
                  {t("talentProfile:garnishmentRestrictions")}
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableHeadingCell
                  width={"150px"}
                  sx={{ padding: "10px 0px 5px 20px" }}
                >
                  {t("talentProfile:dateRange")}
                </StyledTableHeadingCell>
                <StyledTableHeadingCell
                  width={"10px"}
                  sx={{ padding: "10px 0px 5px 5px" }}
                />
                <StyledTableHeadingCell
                  width={"150px"}
                  sx={{ padding: "10px 0px 5px 5px" }}
                />
                <StyledTableHeadingCell
                  width={"150px"}
                  sx={{ padding: "10px 0px 5px 5px" }}
                >
                  {t("talentProfile:amount")}
                </StyledTableHeadingCell>
                <StyledTableHeadingCell sx={{ padding: "10px 0px 5px 5px" }} />
              </TableRow>
              {rowItem?.garnishmentRestrictions.map(
                (gRest: GarnishmentRestriction, index: number) => (
                  <React.Fragment key={index}>
                    <GarnishmentRestrictionItem
                      item={gRest}
                      disableExceptions={disableExceptions}
                      handleExceptionChange={handleExceptionChange}
                      deleteException={deleteException}
                    />
                  </React.Fragment>
                ),
              )}
            </TableBody>
          </Table>
        )}

      {rowItem?.freeMonths && rowItem?.freeMonths?.length > 0 && (
        <Table
          sx={{
            backgroundColor: "#F3F3F7",
            borderRadius: "4px",
            marginTop: "5px",
          }}
        >
          <TableBody>
            <TableRow>
              <StyledTableCell
                colSpan={3}
                sx={{ padding: "10px 0px 0px 20px" }}
              >
                {t("talentProfile:freeMonths")}
              </StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableHeadingCell
                width={"150px"}
                sx={{ padding: "10px 0px 5px 20px" }}
              >
                {t("talentProfile:dateRange")}
              </StyledTableHeadingCell>
              <StyledTableHeadingCell sx={{ padding: "10px 0px 5px 5px" }} />
            </TableRow>
            {rowItem?.freeMonths.map((fMonth: DateRange, index: number) => (
              <React.Fragment key={index}>
                <FreeMonthItem
                  item={fMonth}
                  disableExceptions={disableExceptions}
                  handleExceptionChange={handleExceptionChange}
                  deleteException={deleteException}
                />
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      )}
    </React.Fragment>
  );
};

export default Exceptions;
